import styled from 'styled-components';

import { ExpandIcon } from '../../icons';
import { colors } from 'styles/colors';

export const Container = styled.header<{ MenuOpen: boolean }>(
  ({ MenuOpen }) => `
  display: flex;
  font-size: 1em;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.White};
  border-bottom: 1px solid #74747433;
  top: 0;
  left: 0;
  height: 40px;
  padding: ${MenuOpen ? '25px 40px' : '25px 20px'};
  position: fixed;
  width: 100vw;
  z-index: 899;
  font-size: 13px;
`,
);

export const SelectPlataformInfo = styled.div`
  color: ${colors.text['sub-500']};
  display: flex;
  flex-wrap: nowrap;
  font-size: 12px;
  font-weight: 600;
  gap: 5px;
  margin-left: 5px;
  align-items: center;
`;

export const ChangeAcess = styled.div`
  display: flex;
  position: absolute;
  bottom: -157px;
  left: 0px;
  font-size: 14px;
  font-weight: 600;
  width: 220px;
  flex-direction: column;
  border: 1px solid ${colors.bg['soft-200']};
  background-color: ${colors.bg['weak-100']};
  border-radius: 0px 0px 6px 6px;
  color: black;
  p {
    font-size: 11px;
    font-weight: 500;
    margin: 0px 10px;
    margin-top: 5px;
  } 
  img {
    margin-right: 5px;
  }
  z-index: 1000;
  @media (max-width: 1158px) {
    bottom: -150px;
  }
  @media (max-width: 767px) {
    width: 100%;
    bottom: -138px;
    left: 0px;
  }
  div {
    padding: 10px;
    :hover {
      background-color: #C8D8FD;
      width: 100%;
    }
  }
`;

export const ContainerChangeAcess = styled.div`
  font-size: 11px;
  cursor: pointer;
  color: white;
  display: flex;
  margin-left: 5px;
  flex-wrap: nowrap;
  position: relative;
  @media (max-width: 767px) {
    position: unset;
    margin-left: 10%;
  }
`;

export const ContainerLogoChangeAcess = styled.div<{ content }>`
  display: flex;
  gap: 15px;
  align-items: center;
  &&:hover::after {
    content: "${({ content }) => content}";
    position: absolute;
    top: 100%;
    left: 20px;
    background: ${colors.bg['surface-700']};
    color: white;
    font-size: 11px;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 10000000;
  }
  @media (max-width: 767px) {
    &&:hover::after {
      background-color: unset;
      content: '';
    }
  }
`;

export const UserOptions = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  position: relative;
  justify-content: end;
  align-items: end;
  div {
    display: flex;
  }
`;

export const PermissionContainer = styled.div`
  font-size: 11px;
  color: ${colors.text['sub-500']};
  font-weight: 600;
  display: flex;
  gap: 3px;
  h1 {
    font-size: 11px;
    color: ${colors.Blue300};
  }
`;

export const Welcome = styled.span`
  color: #000;
`;

export const Expand = styled(ExpandIcon)<{ expanded, color }>`
  align-self: center;
  fill: ${({ color }) => color};
  margin-left: 10px;
  transition: transform 0.2s ease-in-out;
  transform: rotate(${({ expanded }) => (expanded ? 180 : 0)}deg);
`;

export const ContainerLogo = styled.div`
  margin-left: 20px;
  display: flex;
  height: 100%;
  align-items: center;
`;

export const List = styled.div`
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #74747433;
  border-radius: 0px 0px 8px 8px;
  border-top: none;
  position: absolute;
  top: 57px;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: ${colors.White};
  gap: 10px;
`;

export const Item = styled.a`
  color: ${colors.Grey300};
  cursor: pointer;
  color: #77818b;
  width: 100%;
  text-decoration: none;
  white-space: nowrap;
`;

export const ItemTitle = styled.span`
  margin-left: 10px;
  color: #000;
  &:hover {
    color: ${colors.Blue300};
  }
`;

export const TabList = styled.div`
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid ${colors.Grey100};
  margin-bottom: 16px;
  padding-top: 20px;
  gap: 32px;
  overflow-x: auto;
`;

export const TabItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 5px;
`;

export const Tab = styled.button<{ isActive: boolean }>`
  position: relative;
  display: inline-block;
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: bold;
  color: ${({ isActive }) => (isActive ? colors.Blue300 : colors.Grey500)};
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    color: ${colors.Blue300};
  }
`;

export const TabLine = styled.div<{ isActive: boolean }>`
  background: ${({ isActive }) => (isActive ? colors.Blue300 : 'transparent')};
  width: 100%;
  height: 10px;
  border-radius: 3px 3px 0 0;
  animation: grow 0.5s;
  @keyframes grow {
    from { width: 0; }
    to { width: 100%; }
  }
`;

export const NewBadge = styled.span`
  position: absolute;
  top: -16px;
  right: -24px;
  background-color: ${colors.Blue300};
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;
